module.exports = __webpack_public_path__ + "static/media/5.4b9dde4c.JPG";